// extracted by mini-css-extract-plugin
export default {"container":"sur_1WzAS","survey":"sur_sur_33l5F","loading":"sur_loa_3ftGT"};